import React from 'react';
import Footer from '../../Footer/Footer';
import Tools from '../Tools/Tools';
import Aboutsub from './Aboutsub';
import Banner from './Banner';
import BusinesssSummery from './BusinesssSummery';
import Contact from './Contact';
import Reviews from './Reviews';
import SubBanner from './SubBanner';

const Home = () => {
    return (
        <div>
            <Banner/>
            <SubBanner/>
            <Tools/>
            <Contact/>
            <Aboutsub/>
            <BusinesssSummery/>
            <Reviews/>
            
            <Footer/>
        </div>
    );
};

export default Home;